/* globals StringBuilder */

/* eslint-disable new-cap */
function XmlElement (elementName) {
    this.ElementName = elementName;
    this.Attributes = [];
    this.Elements = [];
}

// stand-alone version of function that translates any non-printable ASCII characters (<32) with their unicode hex escape value
function EscapeCharacters (str) {
    var outStr = new StringBuilder(),
        c,
        charCode;

    for (c = 0; c < str.length; c += 1) {
        charCode = str.charCodeAt(c);

        if (charCode < 32) {
            // dirty, dirty hack to disguise illegal xml characters...  see comment at end of file for more info.
            outStr.Append("&amp;#x" + charCode.toString(16) + ";");
        }
        else {
            outStr.Append(str.charAt(c));
        }
    }

    return outStr.toString();
}

// Encode except quote is here for use by Json2Xml which encodes only the quote
// by unencoding the quote before doing proper encoding we can avoid double-encoding it.
// It would be marginally more efficient to instead have a method that encodes everything except the quote and then
// additionally encode the quote when not using Json2Xml, but this is more clearly non-disruptive
XmlElement.EncodeExceptQuote = function (str) {
    if (str !== null) {
        str = str.replace(/&quot;/g, "\"");
    }

    return XmlElement.Encode(str);
};

XmlElement.Encode = function (str) {
    // eslint-disable-next-line no-new-wrappers
    str = new String(str);

    if (str !== null) {
        str = str.replace(/&/g, "&amp;");
        str = str.replace(/</g, "&lt;");
        str = str.replace(/>/g, "&gt;");
        str = str.replace(/'/g, "&apos;");
        str = str.replace(/"/g, "&quot;");

        //
        // replace any non-printable ASCII characters (<32) with their unicode hex escape value.
        //
        // test to make sure the javascript implementation supports a function as the second parm and
        // use an alternative method if necessary
        //
        // Does it support a function as second param?
        //
        // eslint-disable-next-line brace-style, max-statements-per-line
        if ("a".replace(/a/, function () { return ""; }).length === 0) {
            str = str.replace(/(\w|\W)/g, XmlElement.CharacterEscape);
        }
        else {
            str = EscapeCharacters(str);
        }
    }

    return str;
};

// translates any non-printable ASCII characters (<32) or any unicode characters (>127) with their unicode hex escape value
XmlElement.CharacterEscape = function (s, match) {
    var charCode = match.charCodeAt(0);

    // eslint-disable-next-line no-new-wrappers
    charCode = new Number(charCode);
    if (charCode < 32) {
        // dirty, dirty hack to disguise illegal xml characters...  see comment at end of file for more info.
        return "&amp;#x" + charCode.toString(16) + ";";
    }

    return match;
};

XmlElement.prototype = {
    AddAttribute: function (attributeName, attributeValue) {
        this.Attributes[attributeName] = XmlElement.Encode(attributeValue);
    },

    AddElement: function (strElement) {
        this.Elements[this.Elements.length] = strElement;
    },

    toString: function () {
        var xml = new StringBuilder(this.Attributes.length + this.Elements.length + 2),
            attribute,
            i;

        xml.Append("<" + this.ElementName + " ");

        for (attribute in this.Attributes) {
            if (this.Attributes.hasOwnProperty(attribute)) {
                xml.Append(attribute + "=\"" + this.Attributes[attribute] + "\" ");
            }
        }

        if (this.Elements.length > 0) {
            xml.AppendLine(">");

            for (i = 0; i < this.Elements.length; i += 1) {
                xml.AppendLine(this.Elements[i]);
            }

            xml.AppendLine("</" + this.ElementName + ">");
        }
        else {
            xml.AppendLine("/>");
        }

        return xml.toString().trim();
    }
};

// ASCII characters 0-31 (except 9, 10, and 13) are illegal in a well-formed XML
// document, even when properly escaped, but we're translating them anyway.
// This was causing problems on the server side, because those characters were
// breaking the XSLT transform and further processing of all XML messages that
// contained the illegal characters.  By escaping the leading ampersand, we can
// trick the server-side processing into overlooking the illegal characters.
// The escaped ampersands are then translated into real ones on the return trip,
// so the data remains intact when removed from the XML.

// We now also 'protect' the leading ampersand for encoded white space characters
// too.  Otherwise the Java server's xsl transform expands them and they get transformed
// into spaces when we reload the translated document.
